import { Dimensions } from 'react-native';

class WebDimensions {
    constructor() {}

    get window() {
        const d = Dimensions.get("window");
        return {
            width: Math.min(960, d.width),
            height: d.height - 60,
        };
    }

    get(p) {
        const d = Dimensions.get("window");
        return {
            width: Math.min(960, d.width),
            height: d.height - 60,
        };
    }
}

const g_dimensions = new WebDimensions();

export default g_dimensions;
